<!-- 订单管理页面 -->
<template>
  <div class="orderManagement">
    <div class="head-area clr">
      <div class="fl clr left-search">
        <div class="fl search-item">
          <div class="fl head-label-area">订单编号</div>
          <Input class="fl" v-model="orderNo" placeholder="请输入订单编号" clearable style="width:200px"></Input>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">订单状态</div>
          <Select v-model="orderStatus" style="width:200px" clearable>
            <Option
              v-for="item in orderStatusList"
              :value="item.dicCode"
              :key="item.dicCode"
            >{{ item.dicName }}</Option>
          </Select>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">商家名称</div>
          <Input class="fl" v-model="storeName" placeholder="请输入商家名称" clearable style="width:200px"></Input>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">用户ID</div>
          <Input class="fl" v-model="userId" placeholder="请输入用户ID" clearable style="width:200px"></Input>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">用户名称</div>
          <Input class="fl" v-model="userName" placeholder="请输入用户昵称" clearable style="width:200px"></Input>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">支付时间</div>
          <DatePicker
            class="fl"
            type="datetimerange"
            v-model="paymentTimeRange"
            format="yyyy-MM-dd"
            placeholder="请选择支付时间范围"
            style="width:200px"
            :options="dateOptions"
            clearable
          ></DatePicker>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">创建时间</div>
          <DatePicker
            class="fl"
            type="datetimerange"
            v-model="createTimeRange"
            format="yyyy-MM-dd"
            placeholder="请选择创建时间范围"
            style="width:200px"
            :options="dateOptions"
            clearable
          ></DatePicker>
        </div>
        <div class="fl search-item" style="margin-left:20px;">
          <Button type="primary" @click="exportData">导出</Button>
          <Button type="primary" @click="showExportList" style="margin-left:10px;">查看导出列表</Button>
        </div>
      </div>
      <div class="fr right-search-btn">
        <Button type="primary" style="margin:0 0 10px;" icon="ios-search" @click="search">查询</Button>
        <Button @click="reset" icon="ios-refresh">重置</Button>
      </div>
    </div>
    <div class="table-area" style="margin-top:10px;">
      <Table :columns="columns" :data="dataList" size="small" :height="tableHeight">
        <template slot-scope="{ row }" slot="orderStatusName">
          <span style="color:red" v-if="row.orderStatusName=='取消订单'">{{row.orderStatusName}}</span>
          <span style="color:#19be6b" v-else-if="row.orderStatusName=='已付款'">{{row.orderStatusName}}</span>
          <span style="color:#808695bf" v-else>{{row.orderStatusName}}</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a
            type="primary"
            size="small"
            style
            @click="edit(index)"
            v-if="row.orderStatusName == '已付款'"
          >退款</a>
          <!-- <Button type="error" size="small" @click="remove(index)">删除</Button> -->
        </template>
      </Table>
    </div>
    <div class="page-area" v-if="dataList.length">
      <Page
        :total="total"
        :current="current"
        :page-size="size"
        show-total
        @on-change="pageChage"
        @on-page-size-change="pageSizeChage"
      ></Page>
    </div>
    <Modal v-model="exportListModal" title="导出列表" width="600">
      <Table :columns="exportListColumns" :data="exportListData" :height="400">
        <template slot-scope="{ row }" slot="status">
            <div v-if="row.status == 'EXPORTING'">导出中</div> 
            <div v-if="row.status == 'SUCCESS'">成功</div> 
            <div v-if="row.status == 'FAILED'">失败</div> 
        </template>
        <template slot-scope="{ row }" slot="exportAction">
          <a v-if="row.status == 'SUCCESS'" @click="downloadExport(row)">下载</a>
        </template>
      </Table>
      <!-- <div class="page-area" v-if="exportListData.length" style="margin-top: 20px;">
        <Page
          :total="exportListTotal"
          :current="exportListCurrent"
          :page-size="exportListSize"
          :page-size-opts="[20, 50, 100, 500, 1000]"
          show-total
          show-sizer
          @on-change="exportListPageChange"
          @on-page-size-change="exportListPageSizeChange"
        ></Page>
      </div> -->
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import { getOrderList, exportOrderList, exportRecordList, downloadExportFile } from '@/api/order.js'

export default {
  data() {
    const now = new Date();
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay() + 1); // 本周一

    const endOfWeek = new Date(now);
    endOfWeek.setDate(now.getDate() + (7 - now.getDay())); // 本周日

    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1); // 本月第一天

    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 本月最后一天

    const startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1); // 上个月第一天

    const endOfLastMonth = new Date(now.getFullYear(), now.getMonth(), 0); // 上个月最后一天

    return {
      orderNo: "",
      storeName: "",
      userId: "",
      orderStatus: "",
      nickName: "",
      userName: "",
      paymentTimeRange: [],
      createTimeRange: [],
      tableHeight: window.innerHeight - 290,
      total: 0,
      current: 1,
      size: 20,
      orderStatusList: [
        { dicCode: '0', dicName: '取消订单' },
        { dicCode: '20', dicName: '待付款' },
        { dicCode: '30', dicName: '已付款' },
        { dicCode: '50', dicName: '交易成功' },
        { dicCode: '40', dicName: '退款失败' },
        { dicCode: '60', dicName: '交易关闭' },
        { dicCode: '70', dicName: '退款中' },
        { dicCode: '80', dicName: '已退款' },
        { dicCode: '90', dicName: '已发起退款' },
        { dicCode: '100', dicName: '活动成功结束' }
      ],
      dateOptions: {
        shortcuts: [
          {
            text: '本周',
            value() {
              return [startOfWeek, endOfWeek];
            }
          },
          {
            text: '本月',
            value() {
              return [startOfMonth, endOfMonth];
            }
          },
          {
            text: '上个月',
            value() {
              return [startOfLastMonth, endOfLastMonth];
            }
          }
        ]
      },
      columns: [
        {
          title: '订单编号',
          key: 'orderNo'
        },
        {
          title: '订单状态',
          key: 'orderStatusName',
          slot: 'orderStatusName'
        },
        {
          title: '商家名称',
          key: 'storeName'
        },
        {
          title: '用户名称',
          key: 'buyUserUserName'
        },
        {
          title: '用户ID',
          key: 'buyUserId',
        },
        {
          title: '支付时间',
          key: 'paymentTime'
        },
        {
          title: '创建时间',
          key: 'createTime'
        },
        // {
        //   title: '操作',
        //   slot: 'action',
        //   width: 100
        // },
      ],
      dataList: [
        // {
        //   id: 1,
        //   nickName: '订单001',
        //   orderNumber: 'cp256005884994387968',
        //   commodityInformation: 'XXXX套餐',
        //   userMsg: '158****7155 | 50002',
        //   stateName: '已支付',
        //   date: '2024-01-01'
        // },
      ],
      // 导出列表相关数据
      exportListModal: false,
      exportListColumns: [
        {
          title: '时间',
          key: 'createTime'
        },
        {
          title: '导出状态',
          slot: 'status',
        },
        {
          title: '操作',
          slot: 'exportAction',
          width: 100
        }
      ],
      exportListData: [],
      exportListTotal: 0,
      exportListCurrent: 1,
      exportListSize: 20
    };
  },
  created() {
    this.findPageDataList()
  },
  methods: {
    search() {
      this.current = 1
      this.findPageDataList()
    },
    reset() {
      this.orderNo = ""
      this.storeName = ""
      this.userId = ""
      this.orderStatus = ""
      this.nickName = ""
      this.paymentTimeRange = []
      this.createTimeRange = []
      this.current = 1
      this.findPageDataList()
    },
    findPageDataList() {
      let params = {
        size: this.size,
        pageIndex: this.current
      }

      if (this.orderNo) {
        params.orderNo = this.orderNo
      }

      if (this.storeName) {
        params.storeName = this.storeName
      }

      if (this.userId) {
        params.userId = this.userId
      }

      if (this.orderStatus) {
        params.orderStatus = this.orderStatus
      }

      if (this.nickName) {
        params.nickName = this.nickName
      }

      if (this.userName) {
        params.userName = this.userName
      }

      if (this.paymentTimeRange && this.paymentTimeRange.length === 2) {
        // 将日期对象格式化为 yyyy-MM-dd HH:mm:ss 格式
        const formatDateTime = (date) => {
          if (!date) return '';
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        params.paymentTimeStart = formatDateTime(this.paymentTimeRange[0]);
        params.paymentTimeEnd = formatDateTime(this.paymentTimeRange[1]);
      }

      if (this.createTimeRange && this.createTimeRange.length === 2) {
        // 将日期对象格式化为 yyyy-MM-dd HH:mm:ss 格式
        const formatDateTime = (date) => {
          if (!date) return '';
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        params.createTimeStart = formatDateTime(this.createTimeRange[0]);
        params.createTimeEnd = formatDateTime(this.createTimeRange[1]);
      }

      getOrderList(params).then(res => {
        if (res.success) {
          this.dataList = res.result.list
          this.total = res.result.total
        }
      })
    },
    remove() { },
    edit() { },
    exportData() {
      let params = {
        // size: this.size,
        // pageIndex: this.current
      }

      if (this.orderNo) {
        params.orderNo = this.orderNo
      }

      if (this.storeName) {
        params.storeName = this.storeName
      }

      if (this.userId) {
        params.userId = this.userId
      }

      if (this.orderStatus) {
        params.orderStatus = this.orderStatus
      }

      if (this.nickName) {
        params.nickName = this.nickName
      }

      if (this.userName) {
        params.userName = this.userName
      }

      if (this.paymentTimeRange && this.paymentTimeRange.length === 2) {
        // 将日期对象格式化为 yyyy-MM-dd HH:mm:ss 格式
        const formatDateTime = (date) => {
          if (!date) return '';
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        params.paymentTimeStart = formatDateTime(this.paymentTimeRange[0]);
        params.paymentTimeEnd = formatDateTime(this.paymentTimeRange[1]);
      }

      if (this.createTimeRange && this.createTimeRange.length === 2) {
        // 将日期对象格式化为 yyyy-MM-dd HH:mm:ss 格式
        const formatDateTime = (date) => {
          if (!date) return '';
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        params.createTimeStart = formatDateTime(this.createTimeRange[0]);
        params.createTimeEnd = formatDateTime(this.createTimeRange[1]);
      }
      exportOrderList(params).then(res => {
        if (res.success) {
          this.$Message.info('正在执行导出操作，请稍后查看导出列表');
        }
      })
    },
    showExportList() {
      // 这里应该调用接口获取导出列表数据
      // 暂时用模拟数据展示
      exportRecordList().then(res => {
        if (res.success) {
          this.exportListData = res.result
          this.exportListModal = true;
        } 
      })
    },
    downloadExport(row) {
      // 使用API接口方式下载文件
      downloadExportFile({id: row.id}).then(res => {
        // 直接处理返回的blob数据
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = '订单导出_' + row.createTime + '.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);
        this.$Message.success('下载成功');
      }).catch(error => {
        this.$Message.error('下载失败：' + (error.message || '未知错误'));
      });
    },
    exportListPageChange(page) {
      this.exportListCurrent = page;
      // 这里应该重新加载数据
    },
    exportListPageSizeChange(size) {
      this.exportListSize = size;
      this.exportListCurrent = 1;
      // 这里应该重新加载数据
    },
    pageChage(page) {
      this.current = page
      this.findPageDataList()
    },
    pageSizeChage(size) {
      this.size = size
      this.findPageDataList()
    },
  }
}

</script>
<style lang='scss' scoped>
.orderManagement {
  .left-search {
    width: calc(100% - 100px);
    .search-item {
      margin-bottom: 10px;
    }
  }
  .right-search-btn {
    width: 100px;
    border-left: 1px solid #e5e6eb;
    padding-left: 20px;
  }
  .head-label-area {
    line-height: 36px;
    margin-left: 10px;
    padding-right: 15px;
    text-align: right;
    min-width: 80px;
  }
}
</style>